export default class EloquaFieldValidationError {
    constructor({ property, value, transKey, }) {
        this.property = property;
        this.value = value;
        this.transKey = transKey;
    }
    static fromJsonBlob(blob) {
        var _a, _b, _c;
        return new EloquaFieldValidationError({
            property: (_a = blob.property) !== null && _a !== void 0 ? _a : '-1',
            value: (_b = blob.value) !== null && _b !== void 0 ? _b : '',
            transKey: (_c = blob.errKey) !== null && _c !== void 0 ? _c : 'formGenericFieldErrorMessage',
        });
    }
    static fromEloquaRespErrBody(errBody) {
        if (!errBody)
            return null;
        try {
            const arr = JSON.parse(errBody);
            if (arr instanceof Array) {
                return arr.map((item) => EloquaFieldValidationError.fromJsonBlob(item));
            }
            console.error(`Error building EloquaFieldValidationError: ${errBody}`);
            return [
                new EloquaFieldValidationError({
                    property: '-622',
                    value: '',
                    transKey: '',
                }),
            ];
        }
        catch (_a) {
            console.error(`Error building EloquaFieldValidationError: ${errBody}`);
            return [
                new EloquaFieldValidationError({
                    property: '-623',
                    value: '',
                    transKey: '',
                }),
            ];
        }
    }
    static fromValidation({ property, value, transKey, }) {
        return new EloquaFieldValidationError({
            property,
            value,
            transKey,
        });
    }
}
